import $ from 'jquery';
import _ from 'underscore';
import { $body, jqGetElemById, isMobile } from 'util/global';
import { onLoad } from 'util/onload';

const API_URL = 'https://chat-assets.frontapp.com/v1/chat.bundle.js';
const CHAT_CONTAINER_ID = 'front-chat-container';
const CUSTOM_LAUNCHER_ELEMENT_ID = 'custom-front-chat-launcher';
// using custom events until the API starts supporting them
const EVENTS = {
    READY: 'FrontChat.ready',
    SHOW: 'FrontChat.show',
    HIDE: 'FrontChat.hide',
};
const CLASSES = {
    ACTIVE: 'active',
    LOADING: 'loading',
};

let chatIsFullyLoaded = false;


/** @param {object} data */
const getStorageKey = data => `brilliant_front_chat__${data.userHash}:${data.conversationFlag}`;


/**
 * @param {object} source
 * @param {object} dest
 */
const copyIdentityProps = (source, dest) => {
    ['email', 'name', 'userHash'].forEach((prop) => {
        if (source[prop]) {
            dest[prop] = source[prop];
        }
    });
};


/** @param {number} n - Number of messages */
const updateUnreadMessageCounter = (n) => {
    const $counter = jqGetElemById(CUSTOM_LAUNCHER_ELEMENT_ID).find('.unread-message-counter');
    $counter.text(n || '');
    $counter.toggle(n > 0);
};


const openChat = () => {
    updateUnreadMessageCounter(0);
    window.FrontChat('show');

    if (chatIsFullyLoaded) {
        $body.trigger(EVENTS.SHOW);
    } else {
        // use this hacky approach until the API starts supporting onReady/onShown event
        const interval = setInterval(() => {
            const chatContainer = document.getElementById(CHAT_CONTAINER_ID);
            if (chatContainer
                    && chatContainer.children.length
                    && chatContainer.children[0].children.length
                    && chatContainer.children[0].children[0].style.opacity === '1') {
                clearInterval(interval);
                chatIsFullyLoaded = true;
                $body.trigger(EVENTS.SHOW);
            }
        }, 50);
    }
};


const closeChat = () => {
    window.FrontChat('hide');
    $body.trigger(EVENTS.HIDE);
};


const setEventHandlers = _.once(() => {
    const $launcher = jqGetElemById(CUSTOM_LAUNCHER_ELEMENT_ID);

    $body.on(EVENTS.READY, () => {
        window.FrontChat('onUnreadChange', (chatData) => {
            const n = chatData.unread_count;

            if (!$launcher.is(':visible') && n > 0) {
                openChat();
            } else if (!$launcher.hasClass('active')) {
                updateUnreadMessageCounter(n);
            }
        });

        $launcher.on('click', (e) => {
            e.preventDefault();
            if ($launcher.hasClass(CLASSES.ACTIVE)) {
                closeChat();
            } else {
                openChat();
            }
        });
    }).on(EVENTS.SHOW, () => {
        $launcher.removeClass(CLASSES.LOADING);
        $launcher.addClass(CLASSES.ACTIVE);
    }).on(EVENTS.HIDE, () => {
        $launcher.removeClass(CLASSES.ACTIVE);
    });
});


/**
 * @param {object} data
 * @param {function} [callback]
 */
const loadFrontChat = (data, callback) => {
    const loadScript = () => {
        const $launcher = jqGetElemById(CUSTOM_LAUNCHER_ELEMENT_ID);

        if ($launcher.is(':visible') && !$launcher.hasClass(CLASSES.ACTIVE)) {
            $launcher.addClass(CLASSES.LOADING);
        }

        setEventHandlers();

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = API_URL;

        script.onload = () => {
            if (window.localStorage && data.conversationFlag) {
                $body.on(EVENTS.SHOW, () => {
                    window.localStorage[getStorageKey(data)] = '1';
                });
            }

            // use this hacky approach until the API starts supporting onHide event
            // we should keep an eye out for changes of such selectors until that
            $body.on('click', `#${CHAT_CONTAINER_ID} .fc-2a549`, () => {
                $body.trigger(EVENTS.HIDE);
            });

            const options = {
                useDefaultLauncher: false,
            };
            copyIdentityProps(data, options);
            window.FrontChat('init', options);

            // add vertical offset if necessary
            const $footerNotifs = jqGetElemById('footer-notifs');
            if ($footerNotifs.length > 0 && !isMobile) {
                let offset = 0;
                if ($footerNotifs.html().trim() !== '') {
                    offset = $footerNotifs.outerHeight();
                }
                if (offset > 0) {
                    // override original styles
                    $('style:last')[0].textContent
                        += `#${CHAT_CONTAINER_ID} .fc-3laqu {`
                            + `height: ${580 - offset}px !important;`
                            + `margin-bottom: ${offset}px !important;`
                        + '}'
                        + '@media (max-height: 600px) and (min-width: 760px) {'
                            + `#${CHAT_CONTAINER_ID} .fc-3laqu {`
                                + `height: calc(100vh - 44px - ${offset}px) !important;`
                            + '}'
                        + '}';
                }
            }

            if (typeof callback === 'function') {
                // FrontChat('init') seems to be asynchronous now and the API doesn't seem to allow
                // to set a callback, so adding a delay manually here until they fix it
                _.delay(callback, 1000);
            }
        };
        const firstScript = document.getElementsByTagName('script')[0];
        firstScript.parentNode.insertBefore(script, firstScript);

        // use this hacky approach until the API starts supporting onReady event
        const interval = setInterval(() => {
            const chatContainer = document.getElementById(CHAT_CONTAINER_ID);
            if (chatContainer && chatContainer.children.length) {
                clearInterval(interval);
                $body.trigger(EVENTS.READY);
            }
        }, 250);
    };

    if (!window.FrontChat) {
        window.FCSP = data.token;
        if (window.isLoaded) {
            loadScript();
        } else {
            onLoad(loadScript);
        }
    } else if (typeof callback === 'function') {
        callback();
    }

    $body.addClass('front-chat-active');
};


/** @param {JQuery} $launcher */
export function launcher($launcher) {
    const data = $launcher.data();
    const delay = parseInt(data.delay, 10);
    const showLauncher = () => $launcher.removeClass('hide');

    $launcher.one('click', () => loadFrontChat(data, () => {
        if (!$launcher.hasClass(CLASSES.ACTIVE)) {
            openChat();
        }
    }));

    if (delay) {
        setTimeout(showLauncher, delay * 1000);
    } else {
        showLauncher();
    }
}


/** @param {JQuery} $launcher */
export function showLauncherIfConversation($launcher) {
    const data = $launcher.data();
    if (window.localStorage && parseInt(window.localStorage[getStorageKey(data)], 10) === 1) {
        launcher($launcher);
    }
}


/** @param {JQuery} $container */
export function loadAndShowOnClick($container) {
    const data = $container.data();
    let $trigger = $container.find('.front-chat-trigger');

    if (!$trigger.length) {
        $trigger = $container;
    }

    $trigger.on('click', (e) => {
        e.preventDefault();
        $body.click(); // hide modals/dropdowns
        loadFrontChat(data, openChat);
    });
}

/** @param {JQuery} $container */
export function loadAndShowOnClickForVue(data) {
    loadFrontChat(data, openChat);
}

/**
 * Load Front and show the chat window as soon as it's loaded
 * @param {object} data - data attributes normally added to a chat controller
 */
export function loadAndShowFrontChat(data = {}) {
    loadFrontChat(data, () => {
        setTimeout(openChat, 1000);
    });
}
